import React, { Component } from 'react';
import { connect } from 'react-redux';
import CollapsibleBox from '../collapsible_box/CollapsibleBox';
import config from '../../config/config';
import './infoBoxes.css';

const SIGN_ICON = 'https://static.retail.autofact.cl/trp/icons/sign-write-purple.svg';
const CHECK_ICON = 'https://static.retail.autofact.cl/trp/icons/check-blue.svg';
const SHIELD_ICON = 'https://static.retail.autofact.cl/trp/icons/autofact-shield-gradient.svg';
const AF_PUBLIC_URL = config.af_public_url;

class InfoBoxes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeBox: '' // 'requirements' or 'payment'
        };
    }

    handleToggleBox = (boxId) => {
        this.setState(prevState => ({
            activeBox: prevState.activeBox === boxId ? null : boxId
        }));
    };

    renderRequirementItem = (text, highlight = false) => {
        return (
            <div className="info-boxes__requirement-item" key={text}>
                <img src={CHECK_ICON} alt="" className="info-boxes__check-icon" />
                <span className={highlight ? 'info-boxes__text--highlight' : ''}>
                    {text}
                </span>
            </div>
        );
    };

    renderRequirementsContent = () => {
        const requirements = [
            { text: <><strong>Clave Única:</strong> necesitas tu clave y acceso al correo asociado para el código de seguridad.</> },
            { text: <><strong>Escanearemos tu Cédula por ambos lados:</strong> por lo que debe ser la física y vigente.</> },
            { text: <><strong>Reconocimiento facial:</strong> tu rostro despejado (sin gafas ni gorro) con buena luz y fondo liso.</> },
            { text: <><strong>Validación de Datos:</strong> confirmaremos tu identidad con datos extras.</> },
            { text: <><strong>Firma:</strong> firmarás a mano directo en la pantalla.</> },
            { text: <><strong>Internet estable:</strong> para un proceso exitoso.</> },
        ];

        return (
            <div className="info-boxes__requirements-list">
                {requirements.map((req, index) => (
                    <div className="info-boxes__requirement-item" key={index}>
                        <img src={CHECK_ICON} alt="" className="info-boxes__check-icon" />
                        <span className={req.highlight ? 'info-boxes__text--highlight' : ''}>
                            {req.text}
                        </span>
                    </div>
                ))}
            </div>
        );
    };

    renderStatusBoxes = () => {
        return (
            <>
                {/* Status: Manual Review */}
                <div className="info-boxes__status-box info-boxes__status-box--warning">
                    <div className="info-boxes__status-badge info-boxes__status-badge--warning">
                        <span>Firma en revisión manual</span>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="8" r="7" stroke="#FF4E04" strokeWidth="1.5"/>
                            <path d="M8 4V8.5L10.5 10" stroke="#FF4E04" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                    </div>
                    <p className="info-boxes__status-text">
                        <strong>Aún no es recomendable</strong> hacer la entrega y pago porque la firma está en revisión de seguridad.
                    </p>
                </div>

                {/* Status: Verified */}
                <div className="info-boxes__status-box info-boxes__status-box--success">
                    <div className="info-boxes__status-badge info-boxes__status-badge--success">
                        <span>Firma verificada y segura</span>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="8" r="7" stroke="#52C41A" strokeWidth="1.5"/>
                            <path d="M5 8L7 10L11 6" stroke="#52C41A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <p className="info-boxes__status-text">
                        <strong>Ahora es más seguro y recomendable</strong> hacer la entrega y pago, las firmas pasaron las revisiones.
                    </p>
                </div>
            </>
        );
    };

    renderPaymentContent = () => {
        return (
            <div className="info-boxes__payment-content">
                <ul className="info-boxes__payment-list">
                    <li>
                        <strong>Recomendamos no realizar el pago ni la entrega del vehículo hasta que las firmas hayan sido verificadas.</strong>
                    </li>
                    <li>
                        Al finalizar el proceso de firma, activaremos el seguimiento detallado del proceso. Los estados de revisión y verificación se verán así (ejemplo):
                    </li>
                </ul>
                {this.renderStatusBoxes()}
            </div>
        );
    };

    renderFinalContent = () => {
        const { stepInfo } = this.props;
        const trackingUrl = stepInfo.transferenceRetailCode ? `${AF_PUBLIC_URL}${stepInfo.transferenceRetailCode}` : undefined;

        return (
            <div className="info-boxes__final-content">
                <ul className="info-boxes__payment-list">
                    <li>
                        <span style={{fontWeight: 600}}>Recomendamos no realizar el pago ni la entrega del vehículo hasta que las firmas hayan sido verificadas.</span>
                    </li>
                    <li>
                        Una vez completadas ambas firmas activaremos seguimiento detallado del proceso. Los estados de revisión y verificación se verán así (ejemplo):
                    </li>
                </ul>
                {this.renderStatusBoxes()}
                {trackingUrl && (
                    <a 
                        href={trackingUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="info-boxes__tracking-button"
                    >
                        Ir al seguimiento de Transferencia
                    </a>
                )}
            </div>
        );
    };

    getStepClassName = () => {
        const { step } = this.props;
        const stepClasses = {
            'initial': 'info-boxes-initial',
            'final': 'info-boxes-final'
        };
        return stepClasses[step] || '';
    };

    renderInitialBoxes = () => {
        const { activeBox } = this.state;

        return (
            <>
                <CollapsibleBox
                    icon={SIGN_ICON}
                    title="Acciones y Requisitos para Firmar"
                    isOpen={activeBox === 'requirements'}
                    onToggle={() => this.handleToggleBox('requirements')}
                >
                    {this.renderRequirementsContent()}
                </CollapsibleBox>

                <CollapsibleBox
                    icon={SHIELD_ICON}
                    title="¿Cuándo hacer el pago y la entrega del vehículo?"
                    subtitle="Por seguridad, aún no es recomendable"
                    isOpen={activeBox === 'payment'}
                    onToggle={() => this.handleToggleBox('payment')}
                >
                    {this.renderPaymentContent()}
                </CollapsibleBox>
            </>
        );
    };

    renderFinalBoxes = () => {
        return (
            <CollapsibleBox
                icon={SHIELD_ICON}
                title="Próximos pasos y recomendaciones en el pago y la entrega del vehículo"
                isOpen={true}
                onToggle={() => {}}
            >
                {this.renderFinalContent()}
            </CollapsibleBox>
        );
    };

    render() {
        const { stepInfo, step } = this.props;

        // Only show for specific companies
        if (!stepInfo?.company_id || !config.directCustomerServiceCompaniesIds.includes(stepInfo.company_id)) {
            return null;
        }

        return (
            <div className={`info-boxes ${this.getStepClassName()}`}>
                {step === 'final' ? this.renderFinalBoxes() : this.renderInitialBoxes()}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo
    };
};

export default connect(mapStateToProps)(InfoBoxes);

